import React, { useEffect, useState } from 'react';

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchNotifications = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/get-notifications.php');
      const data = await res.json();
      setNotifications(data.notifications || []);
    } catch (err) {
      setError('Failed to load notifications.');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const markAsRead = async (id) => {
    await fetch('/api/mark-notification-read.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ notificationId: id })
    });
    fetchNotifications();
  };

  return (
    <div style={{ padding: 'var(--section-padding)' }}>
      <h2 style={{ color: 'var(--color-primary)', fontSize: '2rem', fontWeight: 700, marginBottom: '2rem' }}>Notifications</h2>
      {loading ? (
        <div>Loading notifications...</div>
      ) : error ? (
        <div style={{ color: 'var(--color-error)' }}>{error}</div>
      ) : notifications.length === 0 ? (
        <div style={{ color: 'var(--color-text-light)' }}>No notifications found.</div>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {notifications.map(n => (
            <li key={n.id} style={{ background: n.read ? 'var(--color-bg-alt)' : 'var(--color-surface)', borderRadius: 'var(--border-radius)', boxShadow: 'var(--box-shadow)', marginBottom: '1rem', padding: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: n.read ? 'var(--color-text-light)' : 'var(--color-text)' }}>{n.message}</span>
              {!n.read && (
                <button onClick={() => markAsRead(n.id)} style={{ background: 'var(--color-primary)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.25rem 1rem', cursor: 'pointer' }}>Mark as read</button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NotificationsPage; 